var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full h-screen bg-gray-50"},[_c('Banner'),_c('ActionsViewer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }